import React from 'react';
import ButtonsGeneric from '../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../components/NovoSistema/SelectAndOptions';
import TableCalcsOrcam from '../../../../../components/NovoSistema/TableCalcsOrcam';
import { WrapperInputsNewSystem } from '../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function CAPEX() {
  return (
    <main>
      <div>
        <ContainerSection>
          <div>
            <WrapperInputsNewSystem>
              <SelectAndOptions
                title="Ano Fiscal"
                id="AnoFiscal"
                optionsArray={['', '2020', '2021', '2022']}
                widthPercentage="10%"
              />
              <SelectAndOptions title="Empresa" id="Empresa" optionsArray={['']} widthPercentage="55%" />
              <SelectAndOptions title="CDR" id="CDR" optionsArray={['']} widthPercentage="15%" />
              <SelectAndOptions
                title="Cod. Viabilidade"
                id="CodViabilidade"
                optionsArray={['']}
                widthPercentage="15%"
              />
            </WrapperInputsNewSystem>
            <WrapperInputsNewSystem>
              <InputText title="Descrição" id="Descricao" widthPercentage="60%" />
              <InputText title="Taxa Desconto" id="TaxaDesconto" widthPercentage="10%" />
              <InputText title="Período" id="Periodo" widthPercentage="10%" />
              <InputText title="VPL" id="VPL" widthPercentage="10%" />
            </WrapperInputsNewSystem>
            <TableCalcsOrcam
              type="Item"
              optionsArray={['', 'Pessoal', 'Materia Prima', 'Contas de Consumo', 'Deslocamento', 'Logística']}
            />
          </div>
        </ContainerSection>
        <ButtonsGeneric>
          <button className="success">Salvar</button>
          <button className="error">Cancelar</button>
        </ButtonsGeneric>
      </div>
    </main>
  );
}
